export default __webpack_public_path__ + "08655c30912b328a0f8f87a8c9924e2f.woff";